import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

export class AdjustmentOptions implements RequestModelInterface
{
    public constructor(
        public bestCandidate: AdjustmentOptions.BestCandidates,
        public loadingDose: AdjustmentOptions.LoadingDose,
        public restPeriod: AdjustmentOptions.RestPeriod,
        public steadyStateTarget: AdjustmentOptions.SteadyStateTarget,
        public targetExtraction: AdjustmentOptions.TargetExtraction,
        public formulationAndRouteSelection: AdjustmentOptions.FormulationAndRouteSelected,
    )
    {
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("options");

        element.appendNewElement("bestCandidatesOption", this.bestCandidate);
        element.appendNewElement("loadingOption", this.loadingDose);
        element.appendNewElement("restPeriodOption", this.restPeriod);
        element.appendNewElement("steadyStateTargetOption", this.steadyStateTarget);
        element.appendNewElement("targetExtractionOption", this.targetExtraction);
        element.appendNewElement("formulationAndRouteSelectionOption", this.formulationAndRouteSelection);

        return element;
    }
}

export namespace AdjustmentOptions
{
    export enum BestCandidates {
        BEST_DOSAGE = "bestDosage",
        ALL_DOSAGES = "allDosages",
        BEST_DOSAGE_PER_INTERVAL = "bestDosagePerInterval",
    }
    
    export enum LoadingDose {
        NO = "noLoadingDose",
        ALLOWED = "loadingDoseAllowed",
    }

    export enum RestPeriod {
        NO = "noRestPeriod",
        ALLOWED = "restPeriodAllowed",
    }

    export enum SteadyStateTarget {
        STEADY_STATE = "atSteadyState",
        WITHIN_TREATMENT = "withinTreatmentTimeRange",
    }

    export enum TargetExtraction {
        POPULATION_VALUES = "populationValues",
        APRIORI_VALUES = "aprioriValues",
        INDIVIDUAL_TARGETS = "individualTargets",
        INDIVIDUAL_TARGETS_IF_DEFINITION_EXISTS = "individualTargetsIfDefinitionExists",
        DEFINITION_IF_NO_INDIVIDUAL_TARGET = "definitionIfNoIndividualTarget",
        INDIVIDUAL_TARGETS_IF_DEFINITION_EXISTS_AND_DEFINITION_IF_NO_INDIVIDUAL_TARGET = "individualTargetsIfDefinitionExistsAndDefinitionIfNoIndividualTarget",
    }

    export enum FormulationAndRouteSelected {
        LAST = "lastFormulationAndRoute",
        DEFAULT = "defaultFormulationAndRoute",
        ALL = "allFormulationAndRoutes",
    }
}
